import { render, staticRenderFns } from "./ServiceProviders.vue?vue&type=template&id=33820fad&"
import script from "./ServiceProviders.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports